import React from "react";
import { MainTemplate } from "../../_templates/MainTemplate";

const Menu = [
  {
    src : 'https://content.chungchy.com/PhonicsHero/web_resource/images/main/phonics_pop_book1.png', 
    alt : 'Phonics Pop Book1'
  },
  {
    src : 'https://content.chungchy.com/PhonicsHero/web_resource/images/main/phonics_pop_book2.png', 
    alt : 'Phonics Pop Book2'
  },
  {
    src : 'https://content.chungchy.com/PhonicsHero/web_resource/images/main/phonics_pop_book3.png', 
    alt : 'Phonics Pop Book3'
  }
]

export const Main = () => {
  return (
    <MainTemplate menu={Menu}/>
  );
};